import React, { Component } from 'react';
import { connect } from 'react-redux';
import { colors } from 'helpers/ColorHelper';
import 'navigation/sidebar/SideBar.css';

export default connect(store => ({
  landlordLogoUrl: store.userTypes.landlordLogoUrl,
}))(
  class LandlordLogo extends Component {
    render() {
      return (
        <div style={{ textAlign: this.props.textAlign || 'center', width: '100%' }}>
          {this.renderLogo()}
        </div>
      );
    }

    renderLogo = () => {
      if (this.props.landlordLogoUrl) {
        const marginTop = this.props.marginTop || '6px';
        const margin = `${marginTop} ${this.props.textAlign === 'left' ? 0 : 'auto'}`;
        return (
          <div
            style={{
              margin: margin,
              backgroundImage: `url(${this.props.landlordLogoUrl})`,
              maxWidth: this.props.maxWidth || '100px',
              height: this.props.height || '36px',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: 'contain',
            }}
          />
        );
      }

      if (['qa-concertproperties.com', 'concertproperties.com'].includes(window.CLIENT_URL)) {
        return (
          <img
            src={'/concert-logo.png'}
            height={'40px'}
            alt="landlord-logo"
            style={{ marginBottom: '10px', maxWidth: '100%' }}
          />
        );
      }
      if (window.CLIENT_URL === 'yuhuqa.io') {
        return (
          <div
            className="small-logo"
            style={{
              fontFamily: 'Pacifico, cursive',
              color: colors.YUHU_RED,
              margin: 0,
              textAlign: 'center',
              fontSize: this.props.textHeight || '14px',
            }}
          >
            yuhu
            <span
              style={{
                verticalAlign: 'sub',
                fontSize: '14px',
              }}
            >
              QA
            </span>
          </div>
        );
      }

      return (
        <span
          style={{
            fontFamily: 'Pacifico, cursive',
            color: colors.YUHU_RED,
            margin: 0,
            textAlign: 'center',
            fontSize: this.props.textHeight || '27px',
          }}
        >
          yuhu
        </span>
      );
    };
  }
);
